import React, { PropsWithChildren } from 'react';

function def(a: any, b: any) {
  return a ? a : b;
}

interface SeoProductProps {
  amount: number;
  currency: string;
}

export function SeoProduct(seo: SeoProductProps) {
  return (
    <>
      <meta property='og:price:amount' content={'' + seo.amount} />
      <meta property='og:price:currency' content={seo.currency} />
      <meta property='og:type' content='og:product' />
    </>
  );
}

interface SeoBlogProps {}

export function SeoBlog(seo: SeoBlogProps) {}

interface SEOBasicProps {
  image?: string;
  title: string;
  path: string;
  description: string;
  imageAlt: string;
}

export function SeoBasic(seo: PropsWithChildren<SEOBasicProps>) {
  const siteUrl = 'http://noiseengineering.us';
  const title =
    'Noise Engineering' + (seo.title !== '' ? ' : ' + seo.title : '');
  const image = def(seo.image, '/logo.png');

  return (
    <>
      <meta charSet='utf-8' />
      <link
        rel='preload'
        href='/OCRAStd.woff'
        as='font'
        type='font/woff'
        crossOrigin='anonymous'
      />
      <link rel='canonical' href={siteUrl + seo.path} />
      <title>{title}</title>
      <meta name='twitter:title' content={title} />
      <meta property='og:title' content={title} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='description' content={seo.description} />
      <meta name='og:description' content={seo.description} />
      <meta name='image' content={seo.image} />
      <meta name='twitter:image' content={image} />
      <meta property='og:image' content={image} />
      <meta property='og:image:secure_url' content={seo.image} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta property='og:image:alt' content={seo.imageAlt} />
      <meta name='twitter:url' content={siteUrl + seo.path} />
      <meta name='viewport' content='width=device-width, initial-scale=1' />
      {seo.children}
    </>
  );
}

interface SeoDefaultProps {
  title?: string;
}
export function SeoDefault(props: SeoDefaultProps) {
  return (
    <SeoBasic
      image='/logo.png'
      imageAlt='Noise Engineering Logo'
      title={props.title ? props.title : ''}
      path='/'
      description='Noise Engineering: makers of fine synthesizers, plugins, and more. Get out of the box, and back in.'
    >
      <></>
    </SeoBasic>
  );
}
